import React from "react";
import { isTacticAppWebView } from "../isTacticAppWebView";

export type WebViewNavigateScreen = "user-settings" | "map";

export type WebViewMobileAppAction =
  | { action: "init"; token: string }
  | { action: "navigate"; screen: WebViewNavigateScreen }
  | { action: "openUrl"; url: string };

export type WebViewMobileAppMessage = {
  type: "mobileAppMessage";
} & WebViewMobileAppAction;

export const useMobileAppMessages = (
  onMessage: (message: WebViewMobileAppMessage) => void
) => {
  const isMobileApp = isTacticAppWebView();

  React.useEffect(() => {
    if (!isMobileApp) return;

    const handleMessage = (event: MessageEvent) => {
      const data = JSON.parse(event.data);

      if (!data || data.type !== "mobileAppMessage") return;

      const message = data as WebViewMobileAppMessage;

      onMessage(message);
    };

    //@ts-ignore
    window.addEventListener("message", handleMessage);
    return () => {
      //@ts-ignore
      window.removeEventListener("message", handleMessage);
    };
  }, [isMobileApp, onMessage]);
};
